<style lang="scss" scoped>
.card-table {
  margin-bottom: 0;
}
</style>

<template>
  <section>
    <v-table
      url="/api/v1/customerProfile"
      :filter="[
        {
          name: 'customer'
        },
        {
          name: 'whereIn',
          attributes: [{ column: 'user_id', values: onlineIds }]
        }
      ]"
      :attributes="[
        {
          name: 'Benutzer',
          type: 'LinkProfileCell'
        },
        {
          attribute: 'last_seen_at',
          name: 'letzter Seitenaufruf (wo)'
        },
        {
          attribute: 'last_seen_on',
          name: 'letzter Seitenaufruf (wann)',
          type: 'DateTimeCell'
        },
        {
          attribute: 'last_login_at',
          name: 'letzter Login',
          type: 'DateTimeCell'
        },
        {
          attribute: 'last_login_at',
          name: 'Online seit',
          type: 'MinutesSinceCell'
        }
      ]"
      ref="table"
    ></v-table>
  </section>
</template>

<script lang="babel">
import { isEqual, sortBy } from "lodash";

export default {
  computed: {
    onlineIds() {
      return this.$store.getters['online/onlines'].map(online => online.id);
    }
  },
  watch: {
    onlineIds(newVal, oldVal) {
      if (!isEqual(sortBy(newVal), sortBy(oldVal))) {
        this.$nextTick(() => {
          this.$bus.$emit('refresh-table', this.$refs.table.id);
        });
      }
    }
  }
};
</script>
